import { render, staticRenderFns } from "./EmailDialog.vue?vue&type=template&id=4adbcb2e&"
import script from "./EmailDialog.vue?vue&type=script&lang=js&"
export * from "./EmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adbcb2e')) {
      api.createRecord('4adbcb2e', component.options)
    } else {
      api.reload('4adbcb2e', component.options)
    }
    module.hot.accept("./EmailDialog.vue?vue&type=template&id=4adbcb2e&", function () {
      api.rerender('4adbcb2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/mails/EmailDialog.vue"
export default component.exports